// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationBanner_container__KIHhg","cross":"NotificationBanner_cross__2QgIL","stripe":"NotificationBanner_stripe__1DH36"};